export const generateUUID = () => {
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

export const bytesToSize = bytes => {
	const sizes = ["byte", "KB", "MB", "GB", "TB"];
  
	if (bytes === 0) return "0 byte";
  
	const log = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  
	return Math.round(bytes / Math.pow(1024, log), 2) + " " + sizes[log];
};
  
export const isAccepted = (fileType, acceptedFiles) => {
	if (fileType && acceptedFiles) {
		const mimeType = fileType || "";
		const baseMimeType = mimeType.replace(/\/.*$/, "");

		return acceptedFiles.some(type => {
		const validType = type.trim();
  
		if (validType.endsWith("/*")) {
			return baseMimeType === validType.replace(/\/.*$/, "");
		}
  
		return mimeType === validType;
	  });
	}
	return true;
};

export const getImageURLToBlob = (file) => {
	/*const { rules, accept, acceptType } = this.props;

	const warning = (key) => {
		this.onWarning(key, { ...rules, accept, file });

		throw new Error();
	};

	if (!isAccepted(file.type, accept.map((type) => `${acceptType}/${type}`))) {
		warning("accept");
	}*/

	const ImageURL = URL.createObjectURL(file);

	// if not available rules
	/*if (rules !== null) {
		const { size } = rules;

		if (size * 1024 < file.size) {
			warning("size");
		}
	}*/

	return ImageURL;
}